export enum Routes {
  MemberHome = `^/$`,
  MemberAllBoards = `^/([^/]+)/boards$`,
  EmptySearch = `^//$`,
  Search = `^//([^/]*)`,
  Board = `^/b/([^/]+)`,
  BoardOld = `^/board/[^/]+/([^/]+)`,
  Card = `^/c/([^/]+)`,
  Organization = `^/([^/]+)$`,
}
